import ActionsForm from '@/shared/mixins/actionsForm'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import { loading } from '@/shared/utils/UIHelper'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import Multiselect from 'vue-multiselect'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'

export default {
  name: 'searchocurrence',
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ,
    Multiselect
  },
  data () {
    return {
      title: 'Lista de Chamados',
      empreendimentoInternoArray: [],
      apelidoArray: [],
      apelidoInternoArray: [],
      empreendimentoArray: [],
      SearchItems: {},
      formSearch: {
        Empreendimentoid: [],
        Status: null
      },
      Nome: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      }
    }
  },
  watch: {
    empreendimentoInternoArray () {
      this.formSearch.Empreendimentoid = this.empreendimentoInternoArray.map(x => x.id)
    },
    apelidoInternoArray () {
      this.formSearch.Empreendimentoid = this.apelidoInternoArray.map(x => x.id)
    }
  },
  mounted () {
    this.getEmpreendimento()
  },
  methods: {
    Search () {
      loading.pop()
      loading.push()
      let aux = {...this.formSearch}
      localStoreHelper.controleOcorrencia.nomeEmpreendimento(aux)
      this.$emit('search', aux)
      loading.close()
    },
    Clear () {
      this.empreendimentoInternoArray = []
      this.apelidoInternoArray = []
    },
    getEmpreendimento () {
      EnterpriseRepository.GetEmpreendimento()
        .then((Response) => {
          this.empreendimentoArray = Response.data
          this.apelidoArray = Response.data
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ChangingNameBusiness/components/ChangingNamePainel.js